/* src/app/components/settings/settings.component.scss */
.settings-wrapper {
  width: 100%;
  padding: 24px;
  background: #f4f6fa;
}
.settings-card {
  width: 100%;
  min-height: calc(100vh - 150px);
  display: flex;
  align-items: stretch;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e3e7ef;
  border-radius: 20px;
  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.05), 0 2px 8px rgba(15, 23, 42, 0.03);
}
.settings-sidebar {
  width: 270px;
  flex: 0 0 270px;
  padding: 22px 16px;
  background: #f8faff;
  border-right: 1px solid #e5e7eb;
}
.settings-navigation {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.settings-tab {
  width: 100%;
  min-height: 62px;
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 10px 13px;
  text-align: left;
  border: 1px solid transparent;
  border-radius: 12px;
  background: transparent;
  color: #475569;
  cursor: pointer;
  transition:
    background 0.2s ease,
    color 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;
}
.settings-tab:hover {
  background: #eef2ff;
  color: #253b80;
}
.settings-tab.active {
  background: #ffffff;
  color: #253b80;
  border-color: #dce3f4;
  box-shadow: 0 4px 12px rgba(37, 59, 128, 0.07);
}
.settings-tab.active .tab-icon {
  background: #253b80;
  color: #ffffff;
}
.settings-tab.active .tab-arrow {
  color: #253b80;
  opacity: 1;
  transform: translateX(2px);
}
.settings-tab.active strong {
  color: #253b80;
}
.tab-icon {
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #e9edf7;
  color: #64748b;
  transition: background 0.2s ease, color 0.2s ease;
}
.tab-icon i {
  font-size: 12px;
}
.tab-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.tab-content strong {
  font-size: 13px;
  line-height: 1.4;
  font-weight: 650;
  color: #334155;
}
.tab-content small {
  margin-top: 3px;
  font-size: 10px;
  line-height: 1.4;
  color: #94a3b8;
}
.tab-arrow {
  flex: 0 0 auto;
  font-size: 9px;
  color: #94a3b8;
  opacity: 0.65;
  transition: transform 0.2s ease, color 0.2s ease;
}
.settings-content {
  flex: 1;
  min-width: 0;
  background: #ffffff;
  overflow: hidden;
}
.settings-content-inner {
  width: 100%;
  height: 100%;
  padding: 30px;
  overflow-y: auto;
}
.settings-content-inner::-webkit-scrollbar {
  width: 7px;
}
.settings-content-inner::-webkit-scrollbar-track {
  background: transparent;
}
.settings-content-inner::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.settings-panel {
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
}
.profile-settings {
  width: 100%;
}
.profile-intro {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 24px;
  margin-bottom: 26px;
  background:
    linear-gradient(
      135deg,
      #f8faff 0%,
      #ffffff 100%);
  border: 1px solid #e1e6f0;
  border-radius: 18px;
}
.profile-avatar-section {
  flex: 0 0 auto;
}
.avatar-wrapper {
  width: 112px;
  height: 112px;
  position: relative;
  border-radius: 50%;
  background: #eef2ff;
  border: 4px solid #ffffff;
  box-shadow: 0 0 0 1px #dbe2ef, 0 8px 20px rgba(37, 59, 128, 0.12);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}
.avatar-overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 5px;
  background: rgba(15, 23, 42, 0.72);
  transform: translateY(100%);
  transition: transform 0.2s ease;
}
.avatar-wrapper:hover .avatar-overlay {
  transform: translateY(0);
}
.avatar-action {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
  cursor: pointer;
  transition: background 0.2s ease;
}
.avatar-action i {
  font-size: 9px;
}
.avatar-action:hover {
  background: rgba(255, 255, 255, 0.28);
}
.avatar-action.delete-action:hover {
  background: #dc2626;
}
.hidden-file {
  display: none;
}
.profile-intro-content {
  flex: 1;
  min-width: 0;
}
.profile-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
}
.profile-title-row h2 {
  margin: 0;
  font-size: 22px;
  line-height: 1.3;
  font-weight: 700;
  color: #111827;
}
.profile-title-row p {
  margin: 7px 0 0;
  font-size: 13px;
  line-height: 1.55;
  color: #64748b;
}
.profile-status {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 11px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  color: #15803d;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
}
.profile-status i {
  font-size: 11px;
}
.profile-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 15px;
}
.profile-meta span {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 12px;
  line-height: 1.5;
  color: #64748b;
}
.profile-meta span i {
  color: #253b80;
  font-size: 11px;
}
.profile-section {
  margin-bottom: 22px;
  padding: 24px;
  background: #ffffff;
  border: 1px solid #e4e8ef;
  border-radius: 16px;
}
.section-heading {
  display: flex;
  align-items: flex-start;
  gap: 13px;
  margin-bottom: 22px;
}
.section-heading-icon {
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: #253b80;
  background: #eef2ff;
}
.section-heading-icon i {
  font-size: 14px;
}
.section-heading h3 {
  margin: 0;
  font-size: 16px;
  line-height: 1.4;
  font-weight: 700;
  color: #111827;
}
.section-heading p {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.5;
  color: #64748b;
}
.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}
.field-full {
  grid-column: 1/-1;
}
.profile-field,
.form-field,
.password-field {
  min-width: 0;
}
.profile-field label,
.form-field .field-label,
.password-field label {
  display: block;
  margin-bottom: 8px;
  font-size: 12px;
  line-height: 1.4;
  font-weight: 600;
  color: #334155;
  text-align: left;
}
.required {
  color: #dc2626;
  margin-left: 2px;
}
.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.input-wrapper .input-icon,
.input-wrapper .field-icon,
.input-wrapper > i {
  position: absolute;
  left: 14px;
  z-index: 2;
  color: #94a3b8;
  font-size: 12px;
  pointer-events: none;
}
.input-wrapper .input {
  padding-left: 42px;
}
.input {
  width: 100%;
  height: 48px;
  padding: 0 14px;
  font-family: inherit;
  font-size: 13px;
  line-height: 1.4;
  font-weight: 400;
  color: #111827;
  background: #ffffff;
  border: 1px solid #d8dee8;
  border-radius: 10px;
  outline: none;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;
}
.input::placeholder {
  color: #9ca3af;
}
.input:hover {
  border-color: #b9c2d0;
}
.input:focus {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.09);
}
.input[readonly] {
  color: #64748b;
  background: #f8fafc;
  cursor: not-allowed;
}
.verified-icon {
  position: absolute;
  right: 14px;
  color: #16a34a;
  font-size: 13px;
}
.textarea {
  width: 100%;
  min-height: 110px;
  resize: vertical;
  padding: 13px 14px;
  font-family: inherit;
  font-size: 13px;
  line-height: 1.6;
  color: #111827;
  background: #ffffff;
  border: 1px solid #d8dee8;
  border-radius: 10px;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.textarea::placeholder {
  color: #9ca3af;
}
.textarea:focus {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.09);
}
.gender-options {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}
.gender-option {
  position: relative;
  cursor: pointer;
}
.gender-option input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.gender-card {
  min-height: 70px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 13px 14px;
  border: 1px solid #dce2eb;
  border-radius: 12px;
  background: #ffffff;
  transition:
    border-color 0.2s ease,
    background 0.2s ease,
    box-shadow 0.2s ease;
}
.gender-icon {
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #f1f5f9;
  color: #64748b;
}
.gender-icon i {
  font-size: 13px;
}
.gender-text {
  flex: 1;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
}
.gender-check {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #253b80;
  color: #ffffff;
  opacity: 0;
  transform: scale(0.7);
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.gender-check i {
  font-size: 8px;
}
.gender-option input:checked + .gender-card {
  border-color: #253b80;
  background: #f8faff;
  box-shadow: 0 4px 12px rgba(37, 59, 128, 0.08);
}
.gender-option input:checked + .gender-card .gender-icon {
  background: #253b80;
  color: #ffffff;
}
.gender-option input:checked + .gender-card .gender-check {
  opacity: 1;
  transform: scale(1);
}
.profile-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 18px 20px;
  margin-top: 4px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
}
.actions-info,
.action-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #64748b;
  font-size: 11px;
  line-height: 1.5;
}
.actions-info i,
.action-info i {
  color: #253b80;
  flex: 0 0 auto;
}
.save-profile-btn,
.save-btn,
.update-btn {
  min-height: 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 18px;
  border: 0;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 650;
  color: #ffffff;
  background: #253b80;
  cursor: pointer;
  transition:
    background 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;
}
.save-profile-btn:hover:not(:disabled),
.save-btn:hover:not(:disabled),
.update-btn:hover:not(:disabled) {
  background: #344f91;
  transform: translateY(-1px);
  box-shadow: 0 6px 15px rgba(37, 59, 128, 0.18);
}
.save-profile-btn:disabled,
.save-btn:disabled,
.update-btn:disabled {
  color: #94a3b8;
  background: #e2e8f0;
  cursor: not-allowed;
  box-shadow: none;
}
.password-page {
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
}
.password-header,
.notification-header,
.logo-card-header,
.layout-header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 24px;
}
.password-header-icon,
.notification-header-icon,
.logo-header-icon,
.layout-header-icon {
  width: 46px;
  height: 46px;
  flex: 0 0 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #eef2ff;
  color: #253b80;
}
.password-header-icon i,
.notification-header-icon i,
.logo-header-icon i,
.layout-header-icon i {
  font-size: 16px;
}
.password-header h3,
.notification-header h4,
.logo-title,
.layout-title {
  margin: 0;
  font-size: 19px;
  line-height: 1.4;
  font-weight: 700;
  color: #111827;
}
.password-header p,
.notification-header p,
.logo-subtitle,
.layout-subtitle {
  margin: 5px 0 0;
  font-size: 12px;
  line-height: 1.55;
  color: #64748b;
}
.security-notice {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 15px 16px;
  margin-bottom: 22px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 12px;
  color: #1e40af;
}
.notice-icon {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #dbeafe;
}
.notice-icon i {
  font-size: 11px;
}
.security-notice div:last-child {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.security-notice strong {
  font-size: 12px;
}
.security-notice span {
  font-size: 11px;
  line-height: 1.5;
}
.password-form {
  padding: 24px;
  background: #ffffff;
  border: 1px solid #e3e7ef;
  border-radius: 16px;
}
.password-field {
  margin-bottom: 20px;
}
.error {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 6px 0 0;
  font-size: 11px;
  line-height: 1.5;
  color: #dc2626;
}
.password-tips {
  margin-top: 8px;
  padding: 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}
.tips-title {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 11px;
  font-size: 12px;
  font-weight: 650;
  color: #334155;
}
.tips-title i {
  color: #f59e0b;
}
.tips-list {
  display: flex;
  flex-wrap: wrap;
  gap: 9px 18px;
}
.tips-list span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #64748b;
}
.tips-list span i {
  color: #16a34a;
}
.account-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}
.button {
  min-height: 46px;
  padding: 0 18px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
}
.cancel-btn {
  border: 1px solid #d8dee8;
  color: #475569;
  background: #ffffff;
}
.cancel-btn:hover {
  background: #f8fafc;
}
.layout-settings {
  width: 100%;
}
.layout-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}
.layout-card {
  position: relative;
  padding: 18px;
  background: #ffffff;
  border: 1px solid #dfe4ec;
  border-radius: 16px;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease;
}
.layout-card:hover {
  transform: translateY(-2px);
  border-color: #aeb9d2;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.07);
}
.layout-card.active {
  border-color: #253b80;
  background: #f8faff;
  box-shadow: 0 7px 18px rgba(37, 59, 128, 0.1);
}
.layout-card input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.layout-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}
.layout-option-icon {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #eef2ff;
  color: #253b80;
}
.layout-option-icon i {
  font-size: 13px;
}
.layout-radio {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #cbd5e1;
  border-radius: 50%;
}
.layout-card.active .layout-radio {
  border-color: #253b80;
}
.layout-card.active .layout-radio span {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #253b80;
}
.layout-preview {
  width: 100%;
  height: 190px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  overflow: hidden;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 11px;
}
.layout-preview img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.layout-info h5 {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}
.layout-info p {
  margin: 6px 0 0;
  font-size: 12px;
  line-height: 1.55;
  color: #64748b;
}
.selected-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 13px;
  padding: 5px 9px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 650;
  color: #15803d;
  background: #f0fdf4;
}
.selected-label i {
  font-size: 9px;
}
.notification-settings {
  width: 100%;
}
.notification-card {
  padding: 22px;
  margin-bottom: 18px;
  background: #ffffff;
  border: 1px solid #e2e7ef;
  border-radius: 16px;
}
.card-heading {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding-bottom: 17px;
  margin-bottom: 4px;
  border-bottom: 1px solid #edf0f4;
}
.heading-icon {
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #eef2ff;
  color: #253b80;
}
.heading-icon i {
  font-size: 13px;
}
.card-heading h5 {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}
.card-heading p {
  margin: 4px 0 0;
  font-size: 11px;
  line-height: 1.5;
  color: #64748b;
}
.notification-item {
  min-height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 13px 0;
  border-bottom: 1px solid #eef1f5;
}
.notification-item:last-child {
  border-bottom: 0;
}
.notification-item-content {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}
.notification-item-icon {
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #f1f5f9;
  color: #64748b;
}
.notification-item-icon.desktop {
  color: #253b80;
  background: #eef2ff;
}
.notification-item-icon i {
  font-size: 12px;
}
.notification-text {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.notification-name {
  font-size: 12px;
  line-height: 1.4;
  font-weight: 650;
  color: #334155;
}
.notification-description {
  font-size: 11px;
  line-height: 1.45;
  color: #94a3b8;
}
.toggle-switch {
  position: relative;
  width: 46px;
  height: 25px;
  flex: 0 0 46px;
  cursor: pointer;
}
.toggle-switch input {
  width: 0;
  height: 0;
  opacity: 0;
}
.toggle-switch .slider {
  position: absolute;
  inset: 0;
  background: #cbd5e1;
  border-radius: 999px;
  transition: background 0.2s ease;
}
.toggle-switch .slider::before {
  content: "";
  position: absolute;
  width: 19px;
  height: 19px;
  left: 3px;
  top: 3px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.18);
  transition: transform 0.2s ease;
}
.toggle-switch input:checked + .slider {
  background: #253b80;
}
.toggle-switch input:checked + .slider::before {
  transform: translateX(21px);
}
.notification-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 20px;
}
.save-status {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-right: auto;
  font-size: 11px;
  color: #f59e0b;
}
.save-status i {
  font-size: 5px;
}
.logo-settings {
  width: 100%;
}
.logo-card {
  width: 100%;
  padding: 24px;
  background: #ffffff;
  border: 1px solid #e2e7ef;
  border-radius: 18px;
}
.branding-section {
  padding: 22px 0;
  border-top: 1px solid #edf0f4;
}
.branding-section:first-of-type {
  border-top: 0;
}
.branding-section .section-heading {
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.branding-section .section-heading h5 {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}
.branding-section .section-heading p {
  margin: 4px 0 0;
  font-size: 11px;
  color: #64748b;
}
.file-format {
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 650;
  color: #475569;
  background: #f1f5f9;
}
.logo-upload-box {
  min-height: 230px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 25px;
  text-align: center;
  background: #f8fafc;
  border: 1.5px dashed #cbd5e1;
  border-radius: 15px;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;
}
.logo-upload-box:hover {
  border-color: #253b80;
  background: #f8faff;
}
.logo-upload-box.has-logo {
  min-height: 180px;
  flex-direction: row;
  gap: 20px;
  justify-content: flex-start;
  padding: 20px;
}
.upload-icon {
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  border-radius: 14px;
  background: #eef2ff;
  color: #253b80;
}
.upload-icon i {
  font-size: 20px;
}
.logo-upload-box h6 {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #334155;
}
.logo-upload-box > p {
  margin: 5px 0;
  font-size: 12px;
  color: #64748b;
}
.upload-hint {
  margin-top: 6px;
  font-size: 10px;
  color: #94a3b8;
}
.logo-preview {
  width: 130px;
  height: 130px;
  flex: 0 0 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}
.logo-preview img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.logo-preview-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
}
.logo-preview-info strong {
  font-size: 13px;
  color: #334155;
}
.logo-preview-info span {
  font-size: 11px;
  color: #94a3b8;
}
.remove-logo-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  color: #dc2626;
  background: #fef2f2;
  cursor: pointer;
  transition: background 0.2s ease;
}
.remove-logo-btn:hover {
  background: #fee2e2;
}
.remove-logo-btn i {
  font-size: 11px;
}
.logo-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}
.logo-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding-top: 20px;
  border-top: 1px solid #edf0f4;
}
.save-btn.loading {
  opacity: 0.8;
  cursor: wait;
}
.profile-image-modal {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px;
}
.profile-image-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.72);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
}
.profile-image-container {
  position: relative;
  z-index: 2;
  max-width: min(600px, 90vw);
  max-height: 80vh;
  padding: 10px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
}
.profile-image-container img {
  display: block;
  max-width: 100%;
  max-height: 75vh;
  object-fit: contain;
  border-radius: 10px;
}
.profile-image-close {
  position: absolute;
  z-index: 3;
  top: 22px;
  right: 22px;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 50%;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.16);
  cursor: pointer;
}
.profile-image-close:hover {
  background: rgba(255, 255, 255, 0.25);
}
@media (max-width: 1050px) {
  .settings-sidebar {
    width: 235px;
    flex-basis: 235px;
  }
  .settings-content-inner {
    padding: 24px;
  }
  .profile-title-row h2 {
    font-size: 19px;
  }
  .layout-preview {
    height: 160px;
  }
}
@media (max-width: 800px) {
  .settings-wrapper {
    padding: 16px;
  }
  .settings-card {
    flex-direction: column;
    min-height: auto;
  }
  .settings-sidebar {
    width: 100%;
    flex: none;
    padding: 12px;
    border-right: 0;
    border-bottom: 1px solid #e5e7eb;
  }
  .settings-navigation {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }
  .settings-tab {
    min-height: 54px;
    justify-content: center;
    padding: 8px;
  }
  .tab-content {
    align-items: center;
  }
  .tab-content strong {
    font-size: 11px;
    text-align: center;
  }
  .tab-icon {
    display: none;
  }
  .tab-arrow {
    display: none;
  }
  .settings-content-inner {
    padding: 20px;
  }
}
@media (max-width: 600px) {
  .settings-wrapper {
    padding: 10px;
  }
  .settings-card {
    border-radius: 15px;
  }
  .settings-sidebar {
    padding: 9px;
  }
  .settings-navigation {
    grid-template-columns: repeat(2, 1fr);
  }
  .settings-tab {
    min-height: 50px;
    border-radius: 9px;
  }
  .settings-tab .tab-content strong {
    font-size: 11px;
  }
  .settings-content-inner {
    padding: 14px;
  }
  .profile-intro {
    flex-direction: column;
    align-items: flex-start;
    padding: 18px;
    gap: 18px;
  }
  .profile-title-row {
    flex-direction: column;
    gap: 12px;
  }
  .profile-title-row h2 {
    font-size: 18px;
  }
  .profile-title-row p {
    font-size: 12px;
  }
  .profile-status {
    font-size: 10px;
  }
  .profile-meta {
    flex-direction: column;
    gap: 7px;
  }
  .profile-section,
  .password-form,
  .notification-card,
  .logo-card {
    padding: 17px;
  }
  .section-heading {
    margin-bottom: 18px;
  }
  .section-heading h3 {
    font-size: 15px;
  }
  .section-heading p {
    font-size: 11px;
  }
  .form-grid,
  .logo-form-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .field-full {
    grid-column: auto;
  }
  .gender-options {
    grid-template-columns: 1fr;
  }
  .profile-actions,
  .logo-actions {
    flex-direction: column;
    align-items: stretch;
  }
  .actions-info,
  .action-info {
    justify-content: flex-start;
  }
  .save-profile-btn,
  .logo-actions .save-btn {
    width: 100%;
  }
  .password-header h3,
  .notification-header h4,
  .logo-title,
  .layout-title {
    font-size: 17px;
  }
  .password-header p,
  .notification-header p,
  .logo-subtitle,
  .layout-subtitle {
    font-size: 11px;
  }
  .account-actions {
    flex-direction: column-reverse;
  }
  .account-actions .button {
    width: 100%;
  }
  .layout-grid {
    grid-template-columns: 1fr;
  }
  .layout-preview {
    height: 180px;
  }
  .notification-item {
    align-items: flex-start;
  }
  .notification-description {
    font-size: 10px;
  }
  .notification-actions {
    flex-direction: column;
    align-items: stretch;
  }
  .save-status {
    margin-right: 0;
  }
  .notification-actions .save-btn {
    width: 100%;
  }
  .logo-upload-box.has-logo {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .logo-preview-info {
    align-items: center;
  }
}
@media (max-width: 380px) {
  .settings-navigation {
    grid-template-columns: 1fr;
  }
  .settings-tab {
    justify-content: flex-start;
    padding: 8px 12px;
  }
  .settings-tab .tab-content {
    align-items: flex-start;
  }
  .profile-title-row h2 {
    font-size: 16px;
  }
  .input {
    height: 46px;
    font-size: 12px;
  }
  .textarea {
    font-size: 12px;
  }
  .profile-section {
    padding: 14px;
  }
  .password-form {
    padding: 14px;
  }
}
/*# sourceMappingURL=settings.component.css.map */
